import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Breadcrumb } from 'react-bootstrap'
import Loadable from 'react-loading-overlay'

@observer(['activities', 'agreements', 'orders', 'quotes', 'companies', 'quickbooks', 'globals'])

export default class Order extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadableState: true
    }

    let orderId = this.props.params.orderId

    this.props.quickbooks.getQuickbooksCompanyItems((qbItemArray) => {
      this.props.orders.loadOrder(orderId, qbItemArray, (data) => {
        console.log('Order Data: ', data)
        let row = {
          id: data.companyId
        }

        let agreementId = data.agreementId

        let quoteId = this.props.orders.order.quoteId

        this.loadOrderDetails(row, quoteId, agreementId, qbItemArray)

        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'read', 11, data.id, 1, data.companyId)
      })
    })
  }

  loadOrderDetails(row, quoteId, agreementId, qbItemArray) {
    this.props.companies.loadCompanyDetails(row)
    this.props.quotes.loadQuoteHardware(quoteId, qbItemArray)
    this.props.quotes.loadQuoteAccessory(quoteId, qbItemArray)
    this.props.quotes.loadQuoteFeature(quoteId, qbItemArray)
    if( agreementId > 0 ) {
      this.props.agreements.loadAgreement(agreementId)
    }

    this.setState({
      loadableState: false
    })
  }

  formatTaxExempt(cell, row) {
    return (cell === 1 ? 'Yes' : 'No')
  }

  render() {

    let hardwareList = ''
    //let monthlyList = ''
    //let accessoriesList = ''
    //let featuresList = ''
    let subtotal = 0
    let oneTimeTotal = 0
    let servicesTotal = 0
    let taxTotal = this.props.orders.order.taxTotal
    let shippingCost = this.props.orders.order.shippingCost

    if (this.props.quotes.quoteHardware.length > 0) {
      hardwareList = this.props.quotes.quoteHardware.map((hw) => {
        subtotal += parseFloat(hw.cost) * parseFloat(hw.quantity)
        return (<tr>
          <td>{hw.quantity}</td>
          <td>{hw.hardwareName}</td>
          <td>{hw.hardwareDescription}</td>
          <td>${hw.cost}</td>
          <td>${(hw.quantity * hw.cost).toFixed(2)}</td>
        </tr>)
      })

      /*
      monthlyList = this.props.quotes.quoteHardware.map((hw) => {
        servicesTotal += parseFloat(hw.serviceCost) * parseFloat(hw.quantity)
        return (<tr>
          <td>{ hw.quantity }</td>
          <td>{ this.props.orders.order.serviceName }</td>
          <td>{ this.props.orders.order.serviceDescription }</td>
          <td>${ hw.serviceCost }</td>
          <td>${ (hw.quantity * hw.serviceCost).toFixed(2) }</td>
        </tr>)
      })
      */
    }

    let notesTable = ''

    if (this.props.orders.order.note) {
      notesTable =
        <table style={{ width: '90%', margin: '5%' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={3}><b>NOTES</b></td>
            </tr>
            <tr>
              <td colSpan={3} style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{this.props.orders.order.note}</td>
            </tr>
          </tbody>
        </table>
    }

    let serialNumbersTable = ''

    if (this.props.orders.order.serialNumbers) {
      serialNumbersTable =
        <table style={{ width: '90%', margin: '5%' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={3}><b>Serial Numbers</b></td>
            </tr>
            <tr>
              <td colSpan={3} style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{this.props.orders.order.serialNumbers}</td>
            </tr>
          </tbody>
        </table>
    }

    let termsTable = ''

    if (this.props.orders.order.agreementId > 0) {
      termsTable = 
        <div>
          <table style={{ width: '90%', margin: '5%' }}>
            <tbody>
              <tr>
                <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={3}><b>TERMS AND CONDITIONS</b></td>
              </tr>
              <tr>
                <td colSpan={3} style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{this.props.agreements.agreementDetail.agreement}</td>
              </tr>
            </tbody>
          </table>
        </div>
    }

    { /*
    if (this.props.quotes.quoteAccessory.length > 0) {
      accessoriesList = this.props.quotes.quoteAccessory.map((acc) => {
        subtotal += parseFloat(acc.cost) * parseFloat(acc.quantity)
        return (<tr>
          <td>{ acc.quantity }</td>
          <td>{ acc.accessoryName }</td>
          <td>{ acc.accessoryDescription }</td>
          <td>${ acc.cost }</td>
          <td>${ (acc.quantity * acc.cost).toFixed(2) }</td>
        </tr>)
      })
    }

    if (this.props.quotes.quoteFeature.length > 0) {
      featuresList = this.props.quotes.quoteFeature.map((f) => {
        servicesTotal += parseFloat(f.cost) * parseFloat(f.quantity)
        return (<tr>
          <td>{ f.quantity }</td>
          <td>{ f.featureName }</td>
          <td>{ f.featureDescription }</td>
          <td>${ f.cost }</td>
          <td>${ (f.quantity * f.cost).toFixed(2) }</td>
        </tr>)
      })
    }
    */ }

    let today = new Date()

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title hidden-print">
            <div className="title_left">
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/orders">Orders</Breadcrumb.Item>
                <Breadcrumb.Item active>Order #: {this.props.orders.order.id}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
            <div style={{ height: 'inherit' }}>
              <table style={{ width: '90%', margin: '5%' }}>
                <tbody>
                  <tr>
                    <td colSpan={4} style={{ textAlign: 'center' }}>
                      <img src="/images/logo-white.png" /><br />
                      <small>30724 Benton Road Suite C 302-413<br />Winchester, CA 92596</small>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={4} style={{ paddingTop: '30px', fontSize: '150%', textAlign: 'center' }}><b>{this.props.orders.order.demoName + ' ' + this.props.orders.order.leaseName + ' Order'}</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}>Date: {this.props.orders.order.formattedOrderDate}</td>
                    <td style={{ paddingTop: '30px' }}>Quote # {this.props.orders.order.quoteId} - Order # {this.props.orders.order.qbOrderNumber}</td>
                    <td style={{ paddingTop: '30px' }} >Rep: {this.props.orders.order.userFullName}</td>
                    <td style={{ paddingTop: '30px' }} >Term: {this.props.orders.order.contractTermName}</td>

                  </tr>
                  <tr>
                    <td colSpan={2} style={{ paddingTop: '30px' }}><b>Bill To</b></td>
                    <td colSpan={2} style={{ paddingTop: '30px' }}><b>Ship To</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{this.props.companies.details.name}</small></td>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{this.props.companies.details.name}</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Name</b></small></td>
                    <td><small>{this.props.companies.details.billingAddressName}</small></td>
                    <td><small><b>Name</b></small></td>
                    <td><small>{this.props.companies.details.shippingAddressName}</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Address</b></small></td>
                    <td><small>{this.props.companies.details.billingAddressAddress}</small></td>
                    <td><small><b>Address</b></small></td>
                    <td><small>{this.props.companies.details.shippingAddressAddress}</small></td>
                  </tr>
                  <tr>
                    <td><small><b>City</b></small></td>
                    <td><small>{this.props.companies.details.billingAddressCity}</small></td>
                    <td><small><b>City</b></small></td>
                    <td><small>{this.props.companies.details.shippingAddressCity}</small></td>
                  </tr>
                  <tr>
                    <td><small><b>State</b></small></td>
                    <td><small>{this.props.companies.details.billingAddressState}</small></td>
                    <td><small><b>State</b></small></td>
                    <td><small>{this.props.companies.details.shippingAddressState}</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{this.props.companies.details.billingAddressZipCode}</small></td>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{this.props.companies.details.shippingAddressZipCode}</small></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}></td>
                  </tr>
                  <tr>
                    <td colSpan={4} style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }}><b>Items</b></td>
                  </tr>
                  <tr>
                    <td colSpan={4}>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td><b>QTY</b></td>
                            <td><b>Item</b></td>
                            <td><b>Description</b></td>
                            <td><b>Price</b></td>
                            <td><b>Total</b></td>
                          </tr>
                          {hardwareList}
                          { /* accessoriesList */}
                          { /*
                        <tr>
                          <td style={{ paddingTop: '30px' }} colSpan={ 3 }></td>
                          <td style={{ paddingTop: '30px', textAlign: 'right' }}><b>Activation Fees:</b>&nbsp;&nbsp;</td>
                          <td style={{ paddingTop: '30px' }}>${ (this.props.orders.order.activation > 0) ? this.props.orders.order.activation : '0.00'  }</td>
                        </tr>
                        */ }
                          <tr>
                            <td style={{ paddingTop: '30px' }} colSpan={3}></td>
                            <td style={{ paddingTop: '30px', textAlign: 'right' }}><b>SUBTOTAL:</b>&nbsp;&nbsp;</td>
                            <td style={{ paddingTop: '30px' }}>${subtotal.toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td colSpan={3}></td>
                            <td style={{ textAlign: 'right' }}><b>TAX:</b>&nbsp;&nbsp;</td>
                            <td>${taxTotal}</td>
                          </tr>
                          <tr>
                            <td colSpan={3}></td>
                            <td style={{ textAlign: 'right' }}><b>SHIPPING:</b>&nbsp;&nbsp;</td>
                            <td>${shippingCost}</td>
                          </tr>
                          <tr>
                            <td colSpan={3}></td>
                            <td style={{ textAlign: 'right' }}><b>TOTAL:</b>&nbsp;&nbsp;</td>
                            <td>${(parseFloat(subtotal) + parseFloat(taxTotal) + parseFloat(shippingCost)).toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}></td>
                  </tr>
                  { /*
                <tr>
                  <td colSpan={ 4 } style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }}><b>Monthly Fees</b></td>
                </tr>
                <tr>
                  <td colSpan={ 4 }>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td><b>QTY</b></td>
                        <td><b>Item</b></td>
                        <td><b>Description</b></td>
                        <td><b>Price</b></td>
                        <td><b>Total</b></td>
                      </tr>
                      { monthlyList }
                      { featuresList }
                      <tr>
                        <td colSpan={ 3 }></td>
                        <td style={{ textAlign: 'right' }}><b>TOTAL:</b>&nbsp;&nbsp;</td>
                        <td>${ this.props.orders.order.monthlyTotal }</td>
                      </tr>
                    </tbody>
                  </table>
                  </td>
                </tr>
                */ }
                </tbody>
              </table>
            </div>
            <div>
              {notesTable}
            </div>
            <div className="pagebreak-print">
              {serialNumbersTable}
            </div>
            <div className="clearfix"></div>
              {termsTable}
          </Loadable>
          <div className="clearfix"></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/order.js